export default "__VITE_ASSET__BU5U7uBI__"